import { defineMessages } from 'react-intl';

const messages = defineMessages({
  std_notif: {
    id: '5M/GvW',
    defaultMessage: 'Go to Premium',
  },
  tooltip_facility: {
    id: 'Rt9vgJ',
    defaultMessage:
      'Facilities or locations vary from industry to industry. As an example, a manufacturing organization may have 100 warehouses and 20 offices. This would mean a total of 120 facilities or locations are owned, managed or occupied.',
  },
  estimateYearly: {
    id: 'TGnKzI',
    defaultMessage: 'Estimated yearly costs',
  },
  custom_quote_msg: {
    id: 'KNL30y',
    defaultMessage:
      'Based on the information you have provided on your facilities and reporting needs, please contact us for a custom quote and a discussion about your specific requirements.',
  },
  q1_que_desc: {
    id: '0gyqbl',
    defaultMessage: 'Choose your industry',
  },
  col1_label1: {
    id: 'NDV5Mq',
    defaultMessage: 'Options',
  },
  envizi_heading: {
    id: 'UP8Ykd',
    defaultMessage: 'Estimate your Envizi package price',
  },
  col1_label2: {
    id: 'xLigG0',
    defaultMessage: 'Selection',
  },
  scope3_que2_title: {
    id: 't7I/Pe',
    defaultMessage: 'Value chain insights',
  },
  q3_compliance_state: {
    id: 'NIi2K2',
    defaultMessage: 'Compliance',
  },
  ssc_label: {
    id: 'kdXHFs',
    defaultMessage: 'Source system Connections',
  },
  scope3_title: {
    id: 'tUhefU',
    defaultMessage: 'Scope 3 emissions',
  },
  launch_btn_text: {
    id: 'EgKK7h',
    defaultMessage: 'Start estimate',
  },
  envizi_sub_heading: {
    id: 'tVB3XR',
    defaultMessage:
      'Flexible and modular options designed for organizations at any stage of their GHG or ESG reporting journey.',
  },
  est_feat_pt1: {
    id: 'tAg/rP',
    defaultMessage: 'GHG accounting (Scopes 1, 2 and 3)',
  },
  std_feat_pt3: {
    id: 'WPX2oW',
    defaultMessage: 'Custom PowerReports (Edit/Copy)',
  },
  q1_option6: {
    id: 'ERGPJm',
    defaultMessage: 'Retail',
  },
  std_feat_pt4: {
    id: 'lyJrc0',
    defaultMessage: 'Data capture automation options',
  },
  q1_option7: {
    id: 'kAEsNK',
    defaultMessage: 'Industrial',
  },
  est_feat_pt3: {
    id: '1wPfke',
    defaultMessage: 'Manual and bulk data capture tools',
  },
  std_feat_pt1: {
    id: 'I48Gpv',
    defaultMessage: 'ESG metrics',
  },
  disclaimer_text: {
    id: 'skfHbD',
    defaultMessage:
      'The estimated price is not guaranteed and not a formal offer from IBM, its affiliates or its business partners. Certain factors such as IBM Envizi ESG Suite configuration, add-ons, and discounts will affect the quoted price. IBM business partners set and provide their own IBM Envizi ESG Suite pricing, that may differ from the estimated price. Neither IBM nor its affiliates or its business partners are bound by the provided estimate. Your quoted price will vary from the estimated price. Prices in local currency will vary. Estimated prices is based on a minimum term of 12 months. Prices shown are indicative, may vary by country, exclude any applicable taxes and duties, and are subject to product offering availability in a locale.',
  },
  q1_option4: {
    id: 'Fm3M+y',
    defaultMessage: 'Finance',
  },
  est_feat_pt2: {
    id: 'yNUo/f',
    defaultMessage: 'Audit and workflow tools',
  },
  std_feat_pt2: {
    id: '83pqXa',
    defaultMessage: 'ESG Reporting Frameworks',
  },
  q1_option5: {
    id: 'jtygmI',
    defaultMessage: 'Education',
  },
  q3_state: {
    id: '4Xou5d',
    defaultMessage: 'Greenhouse gas reports',
  },
  q1_option8: {
    id: 'z3FEm2',
    defaultMessage: 'Manufacturing',
  },
  q1_option9: {
    id: 'BVcz9b',
    defaultMessage: 'Real Estate',
  },
  invalid_input_text: {
    id: 'dLePy0',
    defaultMessage: 'Please provide the range between 0-10',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  your_selection: {
    id: 'T4snp2',
    defaultMessage: 'Your Selections',
  },
  estimatedCosts: {
    id: 'pcfkli',
    defaultMessage: 'Estimated annual price range',
  },
  start_over: {
    id: 'i4joXC',
    defaultMessage: 'Start Over',
  },
  prem_pkg_title: {
    id: 'C5xzTC',
    defaultMessage: 'Premium',
  },
  estimateMonthly: {
    id: '2kVSS7',
    defaultMessage: 'Estimated monthly costs',
  },
  std_notif_desc: {
    id: '9CHAKN',
    defaultMessage: 'Based on your input we recommend the next tier',
  },
  q2_state: {
    id: 'IIDnqa',
    defaultMessage: 'Facilities / Locations',
  },
  std_tile_desc2: {
    id: 'U1+KJt',
    defaultMessage:
      'The Standard package is designed for organizations focused on meeting ESG reporting requirements across regulatory, voluntary and benchmark frameworks, including rating agencies.',
  },
  features_label2: {
    id: '6SNoHG',
    defaultMessage: 'All the features of Standard, plus:',
  },
  std_tile_desc1: {
    id: 'hdKapB',
    defaultMessage:
      'ESG reporting which captures and manages ESG data in an auditable, single system of record.',
  },
  q4_ques_desc: {
    id: 'Qm3Dc0',
    defaultMessage:
      'Do you want to manage and disclose metrics that align to ESG reporting frameworks?',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  q3_scope1n2_state: {
    id: 'u0Z9G6',
    defaultMessage: 'Scope 1 and 2 emissions',
  },
  scope3_que1_desc: {
    id: 'SGSfOC',
    defaultMessage: 'Aggregrated reporting at an enterprise level',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  contact_btn: {
    id: 'STAufB',
    defaultMessage: 'Contact us for a quote',
  },
  prem_tile_desc2: {
    id: 'MqSsNG',
    defaultMessage:
      'The Premium package is designed for organizations with a well- established sustainability roadmap, who have complex GHG data management and ESG reporting requirements.',
  },
  prem_tile_desc1: {
    id: '2tm/XA',
    defaultMessage:
      'The complete IBM Envizi ESG Suite with highly customizable GHG and ESG solutions.',
  },
  features_label1: {
    id: 'nsgKtG',
    defaultMessage: 'All the features of Essentials, plus:',
  },
  prem_feat: {
    id: '0qFBr1',
    defaultMessage: 'Custom Software Packaging',
  },
  data_tooltip_desc: {
    id: 'r++xBi',
    defaultMessage:
      'Data capture automation can be supported as a service. The service includes creating an automated data pipleline from source systems to Envizi. Data capture automation is an optional add-on to the Standard Package. The costs stated only include software licence fees associated with data automation, and do not include services costs to deliver the data automation service.',
  },
  q3_que_desc: {
    id: 'OBAz8+',
    defaultMessage:
      'Do you want to manage and report greenhouse gas emissions?',
  },
  data_toogle_title: {
    id: 'OzD3oe',
    defaultMessage: 'Data capture automation as a service',
  },
  q3_valueChain_state: {
    id: 't7I/Pe',
    defaultMessage: 'Value chain insights',
  },
  std_pkg_title: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  esg_tooltip: {
    id: 'TDjr+M',
    defaultMessage:
      'Envizi supports major ESG reporting frameworks such as TCFD, SASB, UN SDGs, GRESB, GRI and others.',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  q1_option10: {
    id: 'pA6Y4L',
    defaultMessage: 'Healthcare',
  },
  q1_option2: {
    id: 'KysdMP',
    defaultMessage: 'Hospitality',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  q1_option3: {
    id: 'I1ZCPK',
    defaultMessage: 'Technology',
  },
  q1_option11: {
    id: '/VnDMl',
    defaultMessage: 'Other',
  },
  q3_scope3_state: {
    id: 'tUhefU',
    defaultMessage: 'Scope 3 emissions',
  },
  showResult_btn: {
    id: 'Qh+wq1',
    defaultMessage: 'Show Result',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  std_feat_pt5: {
    id: 'Qc1y/L',
    defaultMessage: 'Implementation services available',
  },
  std_feat_pt6: {
    id: 'L9hLr7',
    defaultMessage: 'Data accrual',
  },
  q1_option1: {
    id: 'bh4rlK',
    defaultMessage: 'Government',
  },
  quote_btn_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  scope3_que1_title: {
    id: 'NIi2K2',
    defaultMessage: 'Compliance',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  q1_default_label: {
    id: 'fSAINK',
    defaultMessage: 'Select your best match',
  },
  scope3_que2_desc: {
    id: 'elUHLa',
    defaultMessage:
      'Detailed reporting across your value chain and value chain partners',
  },
  back_btn: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  est_pkg_title: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  q1_state: {
    id: 'TqlgrX',
    defaultMessage: 'Industry',
  },
  sub_que_3a: {
    id: 'a0S5eB',
    defaultMessage: 'Question 3a',
  },
  footnoteOne: {
    id: 'Mk+p9O',
    defaultMessage:
      'The estimated price is not guaranteed and not a formal offer from IBM, its affiliates or its business partners. Certain factors such as IBM Envizi ESG Suite configuration, add-ons, and discounts will affect the quoted price. IBM business partners set and provide their own IBM Envizi ESG Suite pricing, that may differ from the estimated price. Neither IBM nor its affiliates or its business partners are bound by the provided estimate. Your quoted price will vary from the estimated price. Prices in local currency will vary. Estimated prices exclude taxes and is based on a minimum term of 12 months.',
  },
  q3_subQue_desc: {
    id: 'Xe0nmJ',
    defaultMessage: 'Scope 1 & 2 emissions',
  },
  sub_que_3b: {
    id: 'bvAalu',
    defaultMessage: 'Question 3b',
  },
  q4_state: {
    id: 'Gg2AcH',
    defaultMessage: 'ESG disclosures',
  },
  features_label: {
    id: 'IZH6Po',
    defaultMessage: 'Features:',
  },
  next_btn: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  est_tile_desc1: {
    id: 'HLUhg0',
    defaultMessage:
      'Just the essentials with emissions, energy, water and waste data all in one platform.',
  },
  q2_que_desc: {
    id: 'dE1tQU',
    defaultMessage:
      'How many facilities or locations does your organization own, manage or occupy?',
  },
  est_tile_desc2: {
    id: 'Xq6b32',
    defaultMessage:
      'The Essentials package is designed for organizations looking to support their climate disclosures with robust GHG calculations and data management functionality covering Scopes 1, 2, 3.',
  },
  thankYouMsg: {
    id: 'QzJufQ',
    defaultMessage:
      'Thank you for requesting a custom quote. We’ll be in contact with you shortly to discuss your specific requirements in more detail.',
  },
  price_tax_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
});

export default messages;
